import { Outlet } from "react-router-dom";
import { AppShell } from "../components/layout";

/** Layout route: AppShell chrome + child page in Outlet (canonical RR pattern). */
export function ProtectedLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
